/* generated by pull.js */
const manifest = {
  "name": "Pause button",
  "description": "Adds a pause button next to the green flag.",
  "credits": [
    {
      "name": "Jeffalo"
    },
    {
      "name": "GarboMuffin"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "tags": [
    "recommended"
  ],
  "enabledByDefault": true
};
export default manifest;
